import { TabPlusIcon } from './TabPlusIcon';

/**
 * author: Austin Andrews
 * id 9E23B225-E972-4369-A94A-C2AAF4C93870
 * name tab-plus
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tab-plus.svg
 * tags
 */
export const TabAddIcon = TabPlusIcon;
export default TabAddIcon